import './LoadingScreen.css'

function LoadingScreen({isLoading}) {
    return <div className="loading-screen">
        <div className="lds-facebook"><div></div><div></div><div></div></div>
    </div>

}

export default LoadingScreen